<select
  class="form-control cursor"
  (change)="filterSearchText.next($event)"
  [(ngModel)]="value"
  [value]="value"
>
  <option value="all">ALL</option>
  <option
    *ngFor="let option of filterOptions || []"
    [value]="option.id"
    class="text-center"
  >
    {{ option.name | uppercase }} - {{ option.currency | uppercase }}
  </option>
</select>
